import { render } from "./tableWithPage.vue?vue&type=template&id=67dbb91d"
import script from "./tableWithPage.vue?vue&type=script&lang=js"
export * from "./tableWithPage.vue?vue&type=script&lang=js"

import "./tableWithPage.vue?vue&type=style&index=0&id=67dbb91d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__